import type { SVGProps } from 'react';
export const WhatsNew = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.54 4.15a2.3 2.3 0 0 1 3.2 0q.15.15.26.33.11-.18.27-.33a2.3 2.3 0 0 1 3.19 0 2.2 2.2 0 0 1 .34 2.73h2c.65 0 1.2.53 1.2 1.2v2.06c0 .61-.47 1.1-1.05 1.18v4a1.21 1.21 0 0 1-1.2 1.19h-9.5c-.3-.01-.61-.13-.84-.36a1.2 1.2 0 0 1-.36-.84v-3.99A1.2 1.2 0 0 1 3 10.14V8.07c0-.66.55-1.19 1.2-1.19h2a2.2 2.2 0 0 1 .34-2.73m4.14 4.08v1.75h4.97V8.23zm3.91 3.1h-3.91v3.83h3.91zm-5.27 3.83v-3.83H5.41v3.83zm0-5.18V8.23H4.35v1.75zm1.4-3.14a9 9 0 0 0 1.27-.23q.4-.15.52-.26a.87.87 0 0 0 0-1.24.9.9 0 0 0-1.29 0q-.12.1-.26.5a5 5 0 0 0-.24 1.23m-1.44 0a9 9 0 0 1-1.27-.23 1.4 1.4 0 0 1-.52-.26.87.87 0 0 1 0-1.24.9.9 0 0 1 1.29 0q.12.1.26.5a5 5 0 0 1 .24 1.23"
      clipRule="evenodd"
    />
  </svg>
);
